<ng-container *transloco="let t">
  <div class="nalaz-4d-l" [formGroup]="form">
    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('4dl.heartworm') }}</mat-label>
      <textarea matInput formControlName="heartworm" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('4dl.anaplasma') }}</mat-label>
      <textarea matInput formControlName="anaplasma" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('4dl.ehrlichia') }}</mat-label>
      <textarea matInput formControlName="ehrlichia" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('4dl.leishmania') }}</mat-label>
      <textarea matInput formControlName="leishmania" rows="4"></textarea>
    </mat-form-field>

    <h3 class="mt-2 mb-1">{{ t('4dl.noteHeading') }}</h3>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ t('4dl.note') }}</mat-label>
      <textarea matInput formControlName="note" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
